import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = ({ darkMode, toggleDarkMode }) => {
  return (
    <div className="about-container">
      <div className="about-content">
        <div className="receipt-nav">
          <div className="receipt-nav-links-text">
            <Link 
              to="/" 
              className="receipt-nav-link-text"
            >
              Home
            </Link>
            <span className="receipt-nav-separator">|</span>
            <Link 
              to="/about" 
              className="receipt-nav-link-text active"
            >
              About
            </Link>
            <span className="receipt-nav-separator">|</span>
            <button 
              className="receipt-dark-toggle-text" 
              onClick={toggleDarkMode}
              aria-label="Toggle dark mode"
            >
              {darkMode ? 'Light Mode' : 'Dark Mode'}
            </button>
          </div>
        </div>

        <h1>About</h1>
        
        <div className="about-section">
          <h2>What is ONECHECK?</h2>
          <p>
            ONECHECK is a free bill splitting tool designed to make splitting checks, 
            receipts, and bills easy and fair. Whether you're dining out with friends, splitting household 
            expenses, or dividing costs for a group activity, ONECHECK helps you calculate exactly how much 
            each person owes.
          </p>
        </div>

        <div className="about-section">
          <h2>Features</h2>
          <div className="features-grid">
            <div className="feature-item">Split bills among multiple people</div>
            <div className="feature-item">Assign specific items to specific people</div>
            <div className="feature-item">Calculate tax and tip proportionally</div>
            <div className="feature-item">Export and share calculations via link</div>
            <div className="feature-item">Dark and light mode</div>
            <div className="feature-item">No account needed</div>
            <div className="feature-item">Completely free to use</div>
          </div>
        </div>

        <div className="about-section">
          <h2>How to Use</h2>
          <ol className="how-to-list">
            <li>Add the names of people splitting the bill</li>
            <li>Add items and their prices</li>
            <li>Click on names to assign items to people</li>
            <li>Enter tax and tip percentages (if applicable)</li>
            <li>View the totals for each person</li>
            <li>Export and share the link if needed</li>
          </ol>
        </div>

        <div className="about-section privacy-notice-box">
          <h2>Privacy Notice</h2>
          <p>
            ONECHECK is completely free and does not store any of your data. All calculations are done 
            locally in your browser. When you export and share a link, the data is encoded in the URL 
            itself.
          </p>
        </div>

        <div className="about-section">
          <div className="donation-section">
            <p>Support ONECHECK</p>
            <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ" className="donation-link" target="_blank" rel="noopener noreferrer">Insert donation link here</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;

